import React from "react";

export const TropicalStormIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="3" fill="none" fillRule="evenodd">
            <g transform="translate(5.000000, 5.000000)">
                <path
                    d="M28.936 21.021l1.136 1.348 1.149-1.337a25.923 25.923 0 0119.701-9.044 25.98 25.98 0 0123.853 15.67.538.538 0 01.04.384.61.61 0 01-.218.302.609.609 0 01-.348.13.538.538 0 01-.36-.137 12.244 12.244 0 00-7.655-2.672c-3.173 0-6.144 1.209-8.386 3.3l-1.227 1.144 1.274 1.091a25.922 25.922 0 019.068 19.722 25.98 25.98 0 01-15.671 23.853.538.538 0 01-.384.04.61.61 0 01-.301-.218.609.609 0 01-.131-.348.538.538 0 01.138-.36 12.244 12.244 0 002.672-7.655 12.26 12.26 0 00-2.889-7.922l-1.136-1.347-1.148 1.336a25.923 25.923 0 01-19.702 9.045A25.98 25.98 0 014.558 51.674a.538.538 0 01-.039-.383.61.61 0 01.218-.301.61.61 0 01.347-.132.538.538 0 01.36.139 12.244 12.244 0 007.656 2.672c3.172 0 6.144-1.21 8.385-3.3l1.227-1.145-1.273-1.091A25.923 25.923 0 0112.37 28.41 25.98 25.98 0 0128.042 4.558a.538.538 0 01.383-.039.61.61 0 01.301.218.61.61 0 01.132.347.538.538 0 01-.139.36 12.244 12.244 0 00-2.672 7.656c0 2.954 1.048 5.738 2.89 7.921z"
                    stroke="#717277"
                    strokeWidth="4"
                />
                <path
                    d="M39.667 46.529a6.862 6.862 0 110-13.725 6.862 6.862 0 010 13.725z"
                    stroke="#717277"
                    strokeWidth="4"
                />
            </g>
        </g>
    </svg>
);
